import { render, staticRenderFns } from "./UcFixedAssetWasteBin.yaml?vue&type=template&id=f71505ea&component"
import script from "./UcFixedAssetWasteBin.yaml?vue&type=script&lang=ts&component"
export * from "./UcFixedAssetWasteBin.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports